import { render, staticRenderFns } from "./userSeniorMess.vue?vue&type=template&id=c50301e8&scoped=true&"
import script from "./userSeniorMess.vue?vue&type=script&lang=js&"
export * from "./userSeniorMess.vue?vue&type=script&lang=js&"
import style0 from "./userSeniorMess.vue?vue&type=style&index=0&id=c50301e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50301e8",
  null
  
)

export default component.exports